import React from "react";
import { AriaButtonProps } from "react-aria";

import { _Button, ButtonProps } from "./_Button";

type Props = AriaButtonProps &
  Pick<
    ButtonProps,
    "leftIcon" | "rightIcon" | "size" | "isLoading" | "testID"
  > & { selected?: boolean };

export function FixedNavigationButton(props: Props) {
  const { selected, testID = "fixed-navigation-button" } = props;

  return (
    <_Button
      color={selected ? "text-inverse" : "text-base"}
      fill={selected ? "background-inverse" : "background-selected-weak"}
      focusStyle="focus-action"
      hoverFill={
        selected ? "background-inverse" : "background-selected-weak-hover"
      }
      iconColor="icon-base"
      shadow="shadow-button"
      shape="border-radius-half"
      loaderColor="icon-success"
      testID={testID}
      {...props}
    />
  );
}
